import { TIER_1_PLAN_ID, SOMETHING } from '../../../plans/constants';

export function requiresUpgrade(plan) {
  if (plan === TIER_1_PLAN_ID) return true;
  else if (plan === SOMETHING) return true;
}
